<template>
  <div
    v-if="modalIsActive"
    class="absolute top-0 left-0 w-full h-full p-2 grid items-center text-center z-50"
    style="background: rgba(0,0,0,0.5)"
    @click="close($event)"
  >
    <div class="bg-white w-full mx-auto shadow-md p-4 pb-2" style="max-width:600px;">
      <div
        class="text-xl text-left font-bold"
        v-if="modalIsActive.title.length > 0"
      >{{modalIsActive.title}}</div>

      <div class="text-left" v-if="modalIsActive.text.length > 0">{{modalIsActive.text}}</div>

      <div class="text-right">
        <button
          @click="submit"
          v-if="!modalIsActive.submitHide"
          class="bg-primary-500 text-white mr-2"
        >{{ submitButtonLabel }}</button>
        <button @click="cancel" class>{{ cancelButtonLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    close(e) {
      if ((e.target.getAttribute("id") === "modal-bg") == true) {
        this.$store.dispatch("modal/close");
      }
    },
    submit() {
      this.modalIsActive.submitFn(this.modalIsActive, true);
      this.$store.dispatch("modal/close");
    },
    cancel() {
      this.modalIsActive.cancelFn(this.modalIsActive, false);
      this.$store.dispatch("modal/close");
    }
  },
  computed: {
    modalIsActive() {
      return this.$store.getters["modal/getCurrent"];
    },
    submitButtonLabel() {
      return this.modalIsActive.getSubmitButtonLabel();
    },
    cancelButtonLabel() {
      return this.modalIsActive.getCancelButtonLabel();
    }
  },
  created() {}
};
</script>
